module.exports = __webpack_public_path__ + "static/fonts/open-sans-v34-latin-300.62d24b94.woff2";